/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type PriceListGetSubKeysType =
  (typeof PriceListGetSubKeysType)[keyof typeof PriceListGetSubKeysType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceListGetSubKeysType = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
} as const;
